import React from 'react';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer, Brush,
} from "recharts";
import { useSelector } from "react-redux";

const AverageScoreChart = ({ data, value,smoothLine }) => {
    const labelFontSize = useSelector((state) => {
        const fontSizes = state.fontManager.fontSizes;
        const normalizedKey = Object.keys(fontSizes).find(
            (key) => key.trim() === "labelFontSize",
        );
        return fontSizes[normalizedKey]  || 16;
    });
    const formatTooltipValue = (value) => value.toFixed(1);
    const rawMin = Math.min(...data.map(item => item.average));
    const rawMax = Math.max(...data.map(item => item.average));

    const padding = (rawMax - rawMin) * 0.01;
    const minScore = (rawMin ).toFixed( 1);
    const maxScore = (rawMax + padding).toFixed(1);

    return (
        <ResponsiveContainer width="100%" height={'100%'} >
            <LineChart
                data={data}
                margin={{
                    top: 0,
                    right: 10,
                    bottom: 40,
                }}
            >
                <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
                <XAxis
                    dataKey="label"
                    tick={{ fontSize: 16, fill: "#333", fontWeight: "500" }}
                    label={{ position: "insideBottom", dy: 20, fontSize: 16, fill: "#555" }}
                    interval="preserveStartEnd"
                />
                <YAxis
                    tick={{ fontSize: 16, fill: "#333" }}
                    domain={[parseFloat(minScore), parseFloat(maxScore)]}
                />
                <Tooltip
                    contentStyle={{ backgroundColor: "#f5f5f5", borderRadius: "10px" }}
                    labelStyle={{ fontWeight: "bold" }}
                    formatter={formatTooltipValue}
                />
                <Legend
                    wrapperStyle={{ bottom: -10, fontSize: `${labelFontSize}px` }}
                    align="center"
                    verticalAlign="top"
                    iconType="circle"
                />
                <Line
                    type={smoothLine ? "monotone" : "linear"}
                    dataKey="average"
                    name={`Average ${value}`}
                    stroke="#8884d8"
                    strokeWidth={3}
                    dot={ false }
                    activeDot={{ r: 6, stroke: "#8884d8", strokeWidth: 2 }}
                />
                <Brush
                    dataKey="date"
                    height={30}
                    stroke="#696969"
                    travellerWidth={12}
                    gap={2}
                    startIndex={0}
                    endIndex={data.length - 1}
                    fill="#D3D3D3"
                    travellerStyle={{
                        stroke: "#696969",
                        fill: "#A9A9A9",
                        cursor: "pointer",
                    }}
                    selectedBoxStyle={{
                        stroke: "#A9A9A9",
                        fill: "rgba(169, 169, 169, 0.2)",
                        cursor: "move",
                    }}
                    padding={{ top: 2, bottom: 2 }}
                />
            </LineChart>
        </ResponsiveContainer>
    );
};

export default AverageScoreChart;
